
export function CustomReload(url = null) {
    const link = document.createElement('a');
    link.href = url != null ? url : window.location.href;
    link.rel = 'noopener noreferrer';
    link.click();
  }